import { Tooltip } from 'bootstrap'

export default {

    mounted(el) {
        const tooltip = new Tooltip(el)
        // console.log("tooltip mounted " + $(el).html());
    },

    updated(el) {
        const tooltip = new Tooltip(el)
        // console.log("tooltip updated " + $(el).html());
    }
}
